import {
  GROW_MESSAGE_LIMIT,
  SET_CHAT_MESSAGES,
  SET_CHAT_REPLIES,
  SET_SHOW_SCROLL_INDICATOR,
  SET_UNREAD_MESSAGE_INDEX,
  SCROLL_TO_UNREAD

} from '@actions/types'
import {
  INITIAL_MESSAGE_LIMIT,
  MAX_MESSAGE_LIMIT,
  MESSAGE_LIMIT_STEP
} from '@redux/saga/chat'

const initialState = {
  messageLimit: INITIAL_MESSAGE_LIMIT,
  messages: [],
  responseMessages: [],
  shouldScrollToUnread: false,
  showScrollIndicator: false,
  unreadMessageIndex: -1
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case GROW_MESSAGE_LIMIT:
    return {
      ...state,
      messageLimit: Math.min(state.messageLimit + MESSAGE_LIMIT_STEP, MAX_MESSAGE_LIMIT)
    }
  case SET_CHAT_MESSAGES:
    return {
      ...state,
      messages: payload
    }
  case SET_CHAT_REPLIES:
    return {
      ...state,
      responseMessages: payload
    }
  case SET_SHOW_SCROLL_INDICATOR:
    return {
      ...state,
      showScrollIndicator: payload
    }
  case SET_UNREAD_MESSAGE_INDEX:
    return {
      ...state,
      unreadMessageIndex: payload,
      showScrollIndicator: payload === -1 ? false : state.showScrollIndicator
    }
  case SCROLL_TO_UNREAD:
    return {
      ...state,
      shouldScrollToUnread: payload
    }
  default:
    return state
  }
}

export default reducer
